import { renderCalcPos, onAnyStandardCell } from '../../helpers/helpers'
import type { CalculationColumn } from '../../types/column-types'

export const stampWidthColumn: CalculationColumn = {
    dataIndex: ['stamp', 'width'],
    title: 'Ш',
    width: 35,
    render: renderCalcPos((r, v) =>
        r.withoutCutting ? r.virtualStamp?.width : (r.stamp?.width ?? v)
    ),
    onCell: onAnyStandardCell,
}
